import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
export default function FollowupSummary() {
  const [expanded, setExpanded] = useState(null);
  const [todayOnly, setTodayOnly] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    const load = async () => {
      try { const { data } = await api.get("/supervisor/followup-summary", { timeout: 30000 }); if (active) { setData(data); setError(""); } }
      catch { if (active) setError("Não foi possível atualizar o acompanhamento da equipe."); }
    };
    load(); const t = setInterval(load, 60000);
    return () => { active = false; clearInterval(t); };
  }, []);
  const [copyStatus, setCopyStatus] = useState("");
  async function copySummary() {
    if (!data?.team.length || error) return;
    const lines = data.team.map(row => {
      const count = todayOnly ? row.waiting_today : row.needs_response;
      const oldest = todayOnly ? row.oldest_waiting_today : row.oldest_waiting;
      return `${row.name}: ${count} ${count === 1 ? "conversa" : "conversas"} sem resposta${oldest ? " · maior espera: " + waitLabel(oldest.minutes) : ""}`;
    });
    const overdue = data.team.reduce((sum, row) => sum + row.overdue, 0);
    try {
      await navigator.clipboard.writeText([todayOnly ? "Pendências de hoje" : "Todas as pendências", ...lines, `Retornos atrasados: ${overdue}`].join("\n"));
      setCopyStatus("Resumo copiado!");
    } catch { setCopyStatus("Não foi possível copiar o resumo."); }
  }
  return <section className="rounded-xl border border-slate-700 bg-slate-900 p-4">
    <h2 className="font-semibold text-pink-300">Resumo de atendimento da equipe</h2>
    <p className="text-xs text-slate-400 mt-1">Atualizado a cada minuto. Horários de Brasília. Cada conta considera até 500 contatos recentes.</p>
    <label className="mt-2 flex items-center gap-2 text-xs">
      Pendências de resposta
      <select value={todayOnly ? "today" : "all"} onChange={e => { setTodayOnly(e.target.value === "today"); setCopyStatus(""); }} className="rounded border border-slate-700 bg-slate-900 p-1">
        <option value="all">Todas as pendências</option>
        <option value="today">De hoje</option>
      </select>
    </label>
    <div className="mt-2 flex flex-wrap items-center gap-2">
      <button type="button" disabled={!data?.team.length || Boolean(error)} onClick={copySummary} className="rounded border border-pink-500/50 px-2 py-1 text-xs text-pink-300 disabled:opacity-50">Copiar resumo da matinal</button>
      <span role="status" className="text-xs text-slate-300">{copyStatus}</span>
    </div>
    {error && <p role="alert" className="text-rose-300">{error}</p>}
    {!data && !error && <p>Carregando acompanhamento…</p>}
    <div className="mt-3 space-y-3">{data?.team.map(row => <React.Fragment key={row.user_id}><details key={row.user_id} className="rounded border border-slate-700 p-3">
      <summary className="cursor-pointer"><strong>{row.name}</strong><span className="block text-xs text-slate-300 mt-1">Precisam de resposta: <button type="button" aria-label={`Ver pendências de ${row.name}`} aria-expanded={expanded === row.user_id} className="underline text-pink-300" onClick={event => { event.preventDefault(); event.stopPropagation(); setExpanded(current => current === row.user_id ? null : row.user_id); }}>{todayOnly ? row.waiting_today : row.needs_response}</button> · Retornos hoje: {row.returns_today} · Atrasados: {row.overdue} · Propostas paradas: {row.stalled_proposals ?? "—"}</span>
      {(todayOnly ? row.oldest_waiting_today : row.oldest_waiting) && <span className="block mt-1 text-xs text-amber-200">Maior espera: {(todayOnly ? row.oldest_waiting_today : row.oldest_waiting).name} · {waitLabel((todayOnly ? row.oldest_waiting_today : row.oldest_waiting).minutes)}</span>}
      </summary>
      {row.returns.length ? row.returns.map(c => <div key={c.phone} className="mt-2 border-t border-slate-700 pt-2 text-xs"><strong>{c.name}</strong> · {c.phone}<span className={`block ${c.overdue ? "text-rose-300" : "text-amber-200"}`}>{new Date(c.return_at).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })}{c.overdue ? " · Atrasado" : ""}</span></div>) : <p className="mt-2 text-xs">Nenhum retorno para hoje ou atrasado.</p>}
    </details>
    {expanded === row.user_id && <div className="max-h-64 overflow-auto rounded border border-slate-700 px-3 py-2 text-xs">
      <strong>Pendências de {row.name}</strong>
      {(row.waiting_list || []).filter(c => !todayOnly || c.today).length ? <ul className="divide-y divide-slate-700">
        {(row.waiting_list || []).filter(c => !todayOnly || c.today).map(c => <li key={c.phone} className="flex justify-between gap-2 py-2"><span>{c.name}{c.name !== c.phone && ` · ${c.phone}`}</span><span className="text-amber-200">{c.minutes == null ? "Sem horário" : waitLabel(c.minutes)}</span></li>)}
      </ul> : <p className="mt-2">Nenhuma conversa nesse filtro.</p>}
    </div>}
    </React.Fragment>)}</div>
  </section>;
}

function waitLabel(minutes) {
  if (minutes < 1) return "menos de 1 min";
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor(minutes / 60) % 24;
  const mins = minutes % 60;
  return [days ? days + " d" : "", hours ? hours + " h" : "", mins ? mins + " min" : ""].filter(Boolean).join(" ");
}
